"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".body {\n  min-height: 400px;\n  padding-bottom: 64px; }\n";
  const fileName = "Body_Body";
  const element = document.querySelector("style[data-sass-component='Body_Body']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Body = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'body'
  }, props.children);
};
var _default = exports.default = Body;